import { api } from '@/scripts/api';

export const SocialMediaAccountTemplateService = {
    post(accountId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/accounttemplate/${accountId}`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject);
        })
    },

    patch(id, accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/accounttemplate/${id}/${accountId}`;
            
            api.msPatch(service, payload)
                .then(resolve)
                .catch(reject);
        });

    },

    delete(id, accountId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/accounttemplate/${id}/${accountId}`;

            api.delete(service)
                .then(resolve)
                .catch(reject);
        })
    },
}